import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-diceIcons-D10',
    templateUrl: './D10.svg',
    styleUrls: ['./diceIcons-D10.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiceIconsD10Component { }
